// extracted by extract-css-chunks-webpack-plugin
module.exports = {"joinButton":"dhhX9h"};